// extracted by mini-css-extract-plugin
module.exports = {"root":"Chip_root__2Lv9F","selected":"Chip_selected__yKd1t"};